import { Component, EventEmitter, Input, Output, signal, inject } from '@angular/core';

import { Connection } from '../../interfaces/connection-interface';
import { ConnectionRequestsService } from '../../services/connection-requests.service';
import { DialogModule } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { NotificationService } from '@angular-monorepo/data-access';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-delete-modal',
  imports: [DialogModule, Button, TooltipModule, TranslatePipe],
  templateUrl: './delete-modal.component.html',
  styleUrl: './delete-modal.component.css',
})
export class DeleteModalComponent {
  private requestService = inject(ConnectionRequestsService);
  private notificationService = inject(NotificationService);
  private translate = inject(TranslateService);

  @Input() connection: Connection | null = null;
  openModal = signal(false);
  @Output() deleteConnection = new EventEmitter<boolean>();

  constructor() {
    this.connection = null;
  }

  handleDelete() {
    if (!this.connection) return;
    this.requestService.deleteConnection(this.connection.id).subscribe((response) => {
      if (response) {
        this.notificationService.showWarning(
          this.translate.instant('connections.messages.deleted'),
        );
      } else {
        this.notificationService.showError(
          this.translate.instant('connections.messages.deleteError'),
        );
      }
      this.deleteConnection.emit(response);
      this.handleClose();
    });
  }

  handleOpen() {
    this.openModal.set(true);
  }

  handleClose() {
    this.openModal.set(false);
  }
}
